import LostEligibilityScreen from 'features/lineOfCredit/screens/lostEligibility/LostEligibilityScreen';
import React from 'react';

export default function Page() {
  return <LostEligibilityScreen />;
}
